import angular from "angular";

import { Calculations } from "@salaxy/core";

import { InvoicesService, ReportsService, SessionService, UiHelpers } from "../../services";
import { CalculationCrudController } from "./CalculationCrudController";

/**
 * Controller for showing possible calculation repair history.
 */
export class CalcRepairInfoController extends CalculationCrudController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["Calculations", "ReportsService", "UiHelpers", "$location", "$routeParams", "SessionService", "InvoicesService"];

  /**
   * Creates a new CalcSharingController
   * @ignore
   */
  constructor(
    calculationsApi: Calculations,
    reportsService: ReportsService,
    uiHelpers: UiHelpers,
    $location: angular.ILocationService,
    $routeParams: any,
    sessionService: SessionService,
    protected invoicesService: InvoicesService,
  ) {
    super(calculationsApi, reportsService, uiHelpers, $location, $routeParams, sessionService, invoicesService);
  }

  /**
   * Implement IController
   */
  public $onInit() {
    super.$onInit();
  }

  /** Shows a selection list for repaired calculations */
  public showRepaired() {
    return this.api.getOData({
        $filter: "status eq 'paymentRepairCopy' and data/originalId eq '" + this.current.id + "'",
        $orderby: "updatedAt desc"
      }).then( (repaired) => {
      return this.uiHelpers.openEditDialog(
        "salaxy-components/modals/calc/CalcRepaired.html",
        repaired.items,
        {},
      );
    });
  }
}
